<template>
    <div
        :style="{ 'border-color': footer.borderColor }"
        class="border-t"
        :class="[!footer.simple ? 'pt-8' : '']"
    >
        <div class="max-w-3xl mx-auto lg:max-w-7xl focus-within:px-4 sm:px-6 lg:px-8">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: "cContainer",
    props: {
        footer: Object,
    },
};
</script>
